<script setup>
import {useUser} from "@/store/user";
import {ref} from "vue";
import UserIcon from "@/assets/icons/UserIcon.vue";
import LogoutIcon from "@/assets/icons/LogoutIcon.vue";
import {useRouter} from "vue-router";
import BlockView from "@/components/common/BlockView.vue";
import { t } from "@/controllerLK/GlobusLocalization";
import {useStore} from "@/store";
import {GoProfilePage} from "@/composables/ModuleCommunication";

const router = useRouter();
const userStore = useUser();
const store = useStore(); 

const isShowDropdown = ref(false);
const isImageLoaded = ref(true);

const moveToSettings = async () => {
  await GoProfilePage();
  isShowDropdown.value = false;
};

</script>

<template>
  <div class="profile">
    <div
      class="profile-image"
      @click="isShowDropdown = !isShowDropdown"
    >
      <img
        v-if="userStore.user?.image && isImageLoaded"
        :src="userStore.user.image"
        alt="Avatar"
        class="profile-image__icon"
        @error="isImageLoaded = false"
      >
      <div 
        v-else 
        class="profile-image__undefined"
        :class="{ 'profile-image__undefined--active': isShowDropdown }"
      >
        {{ userStore.user.firstName.charAt(0).toUpperCase() + userStore.user.lastName.charAt(0).toUpperCase() }}
      </div>
    </div>
    <div
      v-if="isShowDropdown"
      :class="{'profile-dropdown__home': router.currentRoute.value.fullPath === '/lk'}"
      class="profile-dropdown"
    >
      <div
        class="profile-dropdown__item"
        @click="moveToSettings"
      >
        <UserIcon class="profile-dropdown__icon" />
        <span class="profile-dropdown__text">
          {{ userStore.user.userName }}
        </span>
      </div>
      <div
        class="profile-dropdown__item profile-dropdown__item--logout"
        @click="store.isShowLogoutDialog = true; isShowDropdown = false;"
      >
        <LogoutIcon class="profile-dropdown__icon" />
        <span class="profile-dropdown__text">
          {{ t('header_user_profile.exit') }}
        </span>
      </div>
    </div>
  </div>
  <BlockView
    v-if="isShowDropdown"
    @click="isShowDropdown = false"
  />
</template>

<style scoped lang="scss">

.profile {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;

  &-dropdown {
    position: absolute;
    top: 43px;
    right: 0;
    z-index: 2000;
    box-shadow: 1px 2px 10px 0 #131E2726;
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    padding: 6px;
    background: #FFF;
    min-width: 166px;
    max-width: 250px;

    &__icon {
      min-width: 16px;
      min-height: 16px;
      width: 16px;
      height: 16px;
      margin: 2px 5px 2px 0;
      color: #A7A7A7;
    }

    &__text {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    &__item {
      display: flex;
      align-items: center;
      padding: 6px 14px;
      gap: 5px;
      border-radius: 8px;
      transition: all .2s ease-in-out;

      &_home {
        width: 250px;
      }

      &:hover {
        background: #E0F0FF;
      }
    }
  }

  &-image {
    width: 36px;
    height: 36px;
    border-radius: 50%;

    &__undefined {
      border: 1px solid #7B87A51A;
      border-radius: 50%;
      background: #FFFFFF;
      width: 36px;
      height: 36px;
      font-size: 14px;
      font-weight: 400;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #7B87A5;

      &:hover {
        color: #1F9AFF;
      }

      &--active {
        background: rgba(123, 135, 165, 0.1);
        color: #1F9AFF;
      }
    }

    &__icon {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      object-fit: cover;

      &_map-page {
        background: #F7F8FD;
      }
    }
  }
}

</style>